module.exports = __webpack_public_path__ + "img/ys-zl.1f4c20b3.png";